// ==================== Untapped Opportunities Redux Slice ====================
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedBrand: {
    brand_url: '',
    brand_name: '',
    brand_id: null,
    country: '',
    countries: [], // Support multiple countries
    vertical: ''
  },
  opportunities: [],
  loading: false,
  error: null,
  filters: {
    status: 'all',
    priority: 'all',
    category: 'all'
  },
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    itemsPerPage: 20
  }
};

const untappedOpportunitiesSlice = createSlice({
  name: 'untappedOpportunities',
  initialState,
  reducers: {
    setSelectedBrand: (state, action) => {
      state.selectedBrand = action.payload;
    },
    clearSelectedBrand: (state) => {
      state.selectedBrand = initialState.selectedBrand;
    },
    setOpportunities: (state, action) => {
      state.opportunities = action.payload;
    },
    addOpportunity: (state, action) => {
      state.opportunities.push(action.payload);
    },
    updateOpportunity: (state, action) => {
      const index = state.opportunities.findIndex(opp => opp.id === action.payload.id);
      if (index !== -1) {
        state.opportunities[index] = action.payload;
      }
    },
    removeOpportunity: (state, action) => {
      state.opportunities = state.opportunities.filter(opp => opp.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    resetState: (state) => {
      return initialState;
    }
  }
});

export const { 
  setSelectedBrand, 
  clearSelectedBrand, 
  setOpportunities,
  addOpportunity,
  updateOpportunity,
  removeOpportunity,
  setLoading, 
  setError,
  setFilters,
  resetFilters,
  setPagination,
  resetState
} = untappedOpportunitiesSlice.actions;

// Selectors
export const selectSelectedBrand = (state) => state.untappedOpportunities.selectedBrand;
export const selectOpportunities = (state) => state.untappedOpportunities.opportunities;
export const selectLoading = (state) => state.untappedOpportunities.loading;
export const selectError = (state) => state.untappedOpportunities.error;
export const selectFilters = (state) => state.untappedOpportunities.filters;
export const selectPagination = (state) => state.untappedOpportunities.pagination;

export default untappedOpportunitiesSlice.reducer;